import tree from "../../../../components/tree.vue";
import iTable from "../../../../components/Table.vue";
import IPagination from "../../../../components/demo.vue";
import MonthTime from "./MonthTime/MonthTime.vue";
import ChangeTime from "./ChangeTime/ChangeTime.vue";

export default {
    name: 'Duration',
    components: {
        tree,
        iTable,
        IPagination,
        MonthTime,
        ChangeTime
    },
    data() {
        return {
            isCollapse: false,
            stateArrow: true,
            carId: '',
            carIdInput: '',
            isSearch: true,
            activeName: 'first',
            orgId: '',
            height: '320',
            list: [], 
            option: {
                stripe: true,
                border: true,
                loading: false,
                highlightCurrentRow: false, 
                height: false,
                mutiSelect: false, 
                serialNumber: false, 
            },
            columns: [
                {
                    prop: "carId",
                    label: this.$t('VehicleAnalysis.carId'),
                    align: "center",
                },
                {
                    prop: "workTime",
                    label: this.$t('VehicleAnalysis.todayWorkTime'),
                    align: "center",
                },
            ],
            operates: {
                width: 100,
                fixed: "right",
                list: [
                ],
            },
            currentPage: 1,
            pageSize: 10,
            total: 1,
        };
    },
    mounted() {

    },
    methods: {
        toggleSideBar() {
            this.isCollapse = !this.isCollapse
            this.$store.dispatch('menuTab/toggleSideBar', this.isCollapse)
        },
        changeArrow() {
            this.stateArrow = !this.stateArrow
        },
        onkeyUp() {
            this.currentPage = 1
            this.pageSize = 10
            this.queryCarMaintain()
        },
        queryCarMaintain() {
            this.tableLoading = true
            let param = {
                orgId: Number(this.orgId),
                pageSize: this.pageSize,
                pageNum: this.currentPage,
                carId: this.carIdInput,
            };
            this.$store.dispatch('VehicleAnalysis/GET_TODAYWORKTIMEPAGE', param).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        this.list = res.data.data.list;
                        this.$refs.page.CommandTotal = res.data.data.total
                    }
                }
                this.tableLoading = false
            }).catch(err => { this.tableLoading = false })
        },
        handleClick(event) {
            this.activeName = event.name
            if (this.activeName == 'first') {
                this.$nextTick(() => {
                    this.$refs.monthTime.orgId = this.orgId
                    this.$refs.monthTime.getDayUseRate()
                    this.$refs.monthTime.initQuery('all')
                })
            } else {
                this.$nextTick(() => {
                    this.$refs.changeTime.orgId = this.orgId
                    this.$refs.changeTime.getDayUseRate()
                    this.$refs.changeTime.initQuery('all')
                })

            }
        },
        initQuery(item) {
            this.orgId = item.id
            this.queryCarMaintain()
            if (this.activeName == 'first') {
                this.$refs.monthTime.orgId = this.orgId
                this.$refs.monthTime.carId = ''
                this.$refs.monthTime.getDayUseRate()
                this.$refs.monthTime.initQuery('all')
            }
        },
        nodeClick(val) {
            this.orgId = val.label
            this.queryCarMaintain()
            if (this.activeName == 'first') {
                this.$refs.monthTime.orgId = val.label
                this.$refs.monthTime.carId = ''
                this.$refs.monthTime.getDayUseRate()
                this.$refs.monthTime.initQuery('all')
            } else {
                this.$refs.changeTime.orgId = val.label
                this.$refs.changeTime.carId = ''
                this.$refs.changeTime.getDayUseRate()
                this.$refs.changeTime.initQuery('all')
            }
        },
        rowClick(row) {
            this.carId = row.carId
            if (this.activeName == 'first') {
                this.$refs.monthTime.carId = row.carId
                this.$refs.monthTime.getDayUseRate()
                this.$refs.monthTime.initQuery('one')
                this.$refs.monthTime.isShow = false
            } else {
                this.$refs.changeTime.carId = row.carId
                this.$refs.changeTime.getDayUseRate()
                this.$refs.changeTime.initQuery('one')
                this.$refs.changeTime.isShow = false
            }
        },
        changeSize(item) {
            this.pageSize = item.pageSize
            this.currentPage = item.pageNum
            this.queryCarMaintain();
        },
        onResize: function (x, y, width, height) {
            let box = document.getElementById("leftBox");
            box.style.width = width + "px";
        },
    },
};
